import { useContext } from 'react';
import tradeContext from './tradeContext';
import { ExchangeTradeTypes, TradeTypes } from './tradeTypes';

const useTradeState = (): TradeTypes => {
    const context = useContext(tradeContext);

    if (!Object.keys(context).length) {
        throw new Error('TradeContext must be used within its provider');
    }

    const { dispatch } = context;

    const toggleIsShort = () =>
        dispatch({
            type: 'TOGGLE_IS_SHORT',
        });

    const setTradeType = (tradeType: ExchangeTradeTypes) =>
        dispatch({
            type: 'SET_TRADE_TYPE',
            payload: tradeType,
        });

    const setLeverage = (leverage: string) =>
        dispatch({
            type: 'SET_LEVERAGE',
            payload: leverage,
        });

    const setCollateral = (collateral: string) =>
        dispatch({
            type: 'SET_COLLATERAL',
            payload: collateral,
        });

    const setLimitPrice = (limitPrice: string) =>
        dispatch({
            type: 'SET_LIMIT_PRICE',
            payload: limitPrice,
        });

    return {
        ...context,
        toggleIsShort,
        setTradeType,
        setLeverage,
        setCollateral,
        setLimitPrice,
    };
};

export default useTradeState;
